<template>


  <div style="color:white;background-color:RGB(104, 105, 101)" >
      <!-- <p v-bind:class="{thered:tocacu(rowData)<0,thegreen:tocacu(rowData)>=0}">{{tocacu(rowData)}}</p> -->
      <span  style="">{{tocacu(rowData)}}</span>
  </div>

</template>

<script>
import moment from "moment";
// import palette from "google-palette";
export default {
  props:["rowData"],
  mounted(){
  },
  data(){return {  
  }},
  computed:{
    cacuobj(){
  return this.$store.state.currentheader.find(obj=>{return obj.name==="cacu"})
    },
  
  },
  methods:{

    vuemoment(val){
      return moment(val)
    },
    tocacu(rowData){
      let famula=this.cacuobj.famula
      let thenumber=eval(famula)
      thenumber=Math.round(thenumber * 1000) / 1000
      return new Intl.NumberFormat().format(thenumber)
    },
  }
}
</script>

<style scoped>
.thered{
  background:red
}
.thegreen{
  background:green
}
</style>


// WEBPACK FOOTER //
// src/components/utility/commonfields/cacu.vue